import { TimeOffType } from '@sdk/timeOffs/types/TimeOffType';

const getPaidTimeOffTypes = (timeOffTypes: TimeOffType[]): TimeOffType[] => {
  return timeOffTypes.filter((type) => type.paid);
};

export default getPaidTimeOffTypes;
